import { Box, CircularProgress } from "@mui/material";
import React from "react";

export const Loader = () => {
  return (
    <Box
      sx={{
        display: "flex",
        width: "100wh",
        height: "100vh",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <CircularProgress size="3rem" />
    </Box>
  );
};
